<app-layout>
  <router-outlet />
</app-layout>